document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (!customElements.get('slide-show')) {
    class Slideshow extends HTMLElement {
      constructor() {
        super();
        this.swiperPrev = null;
        this.swiperNext = null;
        this.swiperPagination = null;
        this.swiperContainer = null;
        this.swiperScrollbar = null;
        this.slideshowSwiper = null;
      }

      connectedCallback() {
        this.swiperPrev = this.querySelector('.swiper-button-prev');
        this.swiperNext = this.querySelector('.swiper-button-next');
        this.swiperPagination = this.querySelector('.swiper-pagination');
        this.swiperContainer = this.querySelector('.swiper-container');
        this.swiperScrollbar = this.querySelector('.swiper-scrollbar');
        this.slideItems = this.querySelectorAll('.swiper-slide');

        if (this.swiperContainer) {
          this.initSwiper();
        }
        if (this.slideItems.length > 0) {
          this.slideClickHandler();
        }
      }

      disconnectedCallback() {
        if (this.slideshowSwiper) {
          this.slideshowSwiper.destroy(true, true);
          this.slideshowSwiper = null;
        }
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') {
          console.error('Swiper is not defined.');
          return;
        }

        const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        const loop = this.getAttribute('data-loop') === 'true';
        const autoplayDelay =
          Number(this.getAttribute('data-autoplay-delay')) || 3000;

        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.swiperNext,
            prevEl: this.swiperPrev,
          },
          pagination: {
            el: this.swiperPagination,
            clickable: true,
          },
          scrollbar: {
            el: this.swiperScrollbar,
          },
        };

        if (autoplayEnabled && !prefersReducedMotion) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.slideshowSwiper = new Swiper(this.swiperContainer, swiperOptions);
      }

      slideClickHandler() {
        this.slideItems.forEach((item) => {
          item.addEventListener('click', (event) => {
            if (event.target.closest('a, button')) return;

            const link = item.dataset.link;
            if (link) {
              window.location.href = link;
            }
          });
        });
      }
    }

    customElements.define('slide-show', Slideshow);
  }

  const slideshowElement = document.querySelector(
    '.collection-kv-slideshow .swiper-wrapper, .new-slideshow .swiper-wrapper'
  );

  if (slideshowElement && slideshowElement.dataset.height === 'true') {
    const updateMaxHeight = () => {
      const ratio = window.innerWidth > 850 ? 2.5 : 390 / 580;
      slideshowElement.style.maxHeight = `${window.innerWidth / ratio}px`;
    };

    updateMaxHeight();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateMaxHeight, 200);
    });
  }
});
